import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/categories/:id/questions`,
  CREATE: `${apiUrlConfig.apiEndPoint()}/survey_templates/:id/survey_template_questions`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/survey_template_questions/:id`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/survey_template_questions/:id`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/survey_template_questions/:id`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class SurveyTemplateQuestionApi {
  /**
   * add new question
   */
  static addNew(
    question,
    survey_template_question_answers_attributes,
    ownerId,
    input_type_id
  ) {
    const CREATE_URL = insertIdToUrl(URLS.CREATE, ownerId);
    const data = {
      survey_template_question: {
        question,
        survey_template_question_answers_attributes,
        input_type_id
      },
    };

    return AuthenticatedRequestService.post(CREATE_URL, data);
  }

  /**
   * gets all questions
   */
  static getAll(categoryId) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, categoryId);

    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * get question details
   */
  static getDetails(questionId) {
    const SHOW_URL = insertIdToUrl(URLS.SHOW, questionId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  /**
   * updates question
   */
  static update(
    questionId,
    question,
    survey_template_question_answers_attributes,
    answer_order,
    has_weight = false
  ) {
    const UPDATE_URL = insertIdToUrl(URLS.UPDATE, questionId);

    const data = {
      survey_template_question: {
        has_weight,
        question,
        survey_template_question_answers_attributes,
        answer_order,
      },
    };

    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }

  /**
   * deletes question
   */
  static delete(questionId) {
    const DELETE_URL = insertIdToUrl(URLS.UPDATE, questionId);
    const data = {
      survey_template_question: {
        is_deleted: true,
      },
    };

    return AuthenticatedRequestService.patch(DELETE_URL, data);
  }
}

export default SurveyTemplateQuestionApi;



// WEBPACK FOOTER //
// ./src/apis/questions/CategoryQuestion.js